import { serverHttp } from "@/plugins/axios";

export const currentUser = function() {
    return serverHttp.get("/api/current-user");
};

export const currentStudentInfo = function() {
    return serverHttp.get("/api/current-student/info");
};

export const currentStudentBasicInfo = function() {
    return serverHttp.get("/api/current-user");
};

export const updateCurrentStudentBasicInfo = function(data: any) {
    return serverHttp.put("/api/current-user", data);
};

export const currentStudentIdentityInfo = function() {
    return serverHttp.get("/api/current-user/identity");
};

export const updateCurrentStudentIdentityInfo = function(data: any) {
    return serverHttp.put("/api/current-user/identity", data);
};

export const updateCurrentStudentInfo = function(data: any) {
    return serverHttp.put("/api/current-student/info", data);
};

export const myPlans = function(params: object) {
    return serverHttp.get("/api/current-user/enrollment-plans", {
        params: params
    });
};

export const myPlanDetail = function(planId: number) {
    return serverHttp.get(`/api/current-user/enrollment-plans/${planId}`);
};

export const updateMyPlanAttachments = function(planId: number, attachments: { code: string; files: string[] }[]) {
    return serverHttp
        .put(`/api/enrollments/plans/${planId}/student-registration-attachments`, {
            attachments: attachments
        })
        .then(response => {
            return response.data.data;
        });
};

export const myClasses = function(params: object) {
    return serverHttp.get("/api/current-user/classes", {
        params: params
    });
};

export const myCertificates = function() {
    return serverHttp.get("/api/current-user/certificates");
};

export const myClassesDetail = function(classId: number) {
    return serverHttp.get(`/api/current-user/classes/${classId}/detail`);
};
